import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["sections"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { useAddSectionMutation, useListSectionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Sections',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: undefined
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['label'];
      }
    },
    defaultFilters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: 'calc(100vh - 200px)'
    },
    defaultUseNested: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var useNested = ref(props.defaultUseNested);
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: true
      }, {
        value: 'hasChildren'
      }, {
        value: 'labelI18n.en'
      }, {
        value: 'labelI18n.de'
      }, {
        value: 'label'
      }, {
        value: 'taxonomy.label'
      }, {
        value: 'sort'
      }, {
        value: 'actions'
      }].filter(function (o) {
        var _props$columns;
        return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var filters = ref({
      taxonomyIds: [],
      text: ''
    });
    var variables = computed(function () {
      var baseFilters = _objectSpread(_objectSpread({}, props.defaultFilters), filters.value);
      var withRootFlag = useNested.value ? _objectSpread(_objectSpread({}, baseFilters), {}, {
        parentIsNull: true
      }) : baseFilters;
      return {
        filters: withRootFlag,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListSectionsQuery = useListSectionsQuery(variables),
      result = _useListSectionsQuery.result,
      refetch = _useListSectionsQuery.refetch,
      loading = _useListSectionsQuery.loading;
    var items = computed(function () {
      var _result$value$listSec, _result$value;
      return (_result$value$listSec = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listSections) !== null && _result$value$listSec !== void 0 ? _result$value$listSec : [];
    });

    // Recursive functionality
    var _flattenSections = function flattenSections(sections) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return sections.reduce(function (acc, section) {
        var childSections = section.sections,
          sectionData = _objectWithoutProperties(section, _excluded);
        acc.push(_objectSpread(_objectSpread({}, sectionData), {}, {
          level: level,
          parentId: parentId,
          hasChildren: childSections && childSections.length > 0
        }));
        if (childSections && childSections.length > 0) {
          acc.push.apply(acc, _toConsumableArray(_flattenSections(childSections, level + 1, section.id)));
        }
        return acc;
      }, []);
    };
    var flatItems = computed(function () {
      return useNested.value ? _flattenSections(items.value || []) : [];
    });
    var rootItems = computed(function () {
      return flatItems.value.filter(function (item) {
        return item.level === 0;
      });
    });
    var displayItems = computed(function () {
      return useNested.value ? rootItems.value : items.value;
    });
    var selected = computed(function () {
      return displayItems === null || displayItems === void 0 ? void 0 : displayItems.value.filter(function (section) {
        return (currentIds.value || []).filter(Boolean).includes(section.id);
      }).map(function (section) {
        return section.id;
      });
    });
    var _useAddSectionMutatio = useAddSectionMutation(),
      addSection = _useAddSectionMutatio.mutate;
    var onInput = function onInput(val) {
      if (_.isEqual(val, currentIds.value)) {
        return;
      }
      emit('update:modelValue', val);
      emit('input', val);
    };
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countSections) || 0;
    });
    var editDialog = ref(false);
    var editedItem = ref({
      labelI18n: {}
    });
    var expanded = ref([]);
    var toggleExpand = function toggleExpand(item) {
      var index = expanded.value.findIndex(function (expandedItem) {
        return expandedItem.id === item.id;
      });
      if (index > -1) {
        expanded.value.splice(index, 1);
      } else {
        expanded.value.push(item);
      }
    };
    return {
      __sfc: true,
      props: props,
      useNested: useNested,
      emit: emit,
      currentIds: currentIds,
      headers: headers,
      options: options,
      filters: filters,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      flattenSections: _flattenSections,
      flatItems: flatItems,
      rootItems: rootItems,
      displayItems: displayItems,
      selected: selected,
      addSection: addSection,
      onInput: onInput,
      itemCount: itemCount,
      editDialog: editDialog,
      editedItem: editedItem,
      expanded: expanded,
      toggleExpand: toggleExpand
    };
  }
});